const RoutineRoot = 'routines';

export const routinesPaths = {
  root: RoutineRoot,
};
